import footerImage from 'src/assets/footerImage.png';

import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Thankyou from './thankyou'
import { APP_CONSTANTS } from 'src/consumer/constants'
import logo from 'src/assets/logo_brand.png'
import { useNavigate } from 'react-router-dom'
import { useContext } from 'react'
import { LocalizationContext } from 'src/consumer/context/LocalizationContext'
import Spinner from 'react-bootstrap/Spinner'
import { apiURL, commonHeadersWeb } from 'src/consumer/services'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import { isValidEmail } from 'src/clinic/views/onboardng/clinicBrand/components/utils'
import { isSuccessResponse } from './passwordResetUtils'
import './ForgotPasswordStyles.css'

const ForgotPassword = ({ Email }) => {
  const [email, setEmail] = useState('')
  const [isLoading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigate()

  const pageId = 'forgotPasswordPage'

  const { localizedDataLoading, localizedData, localizedDataError } =
    useContext(LocalizationContext)
  const localizedStrings = localizedData?.[pageId]

  const validateEmail = (email) => {
    if (!email) return localizedStrings?.email_required || 'Email is required'
    if (!isValidEmail(email)) return localizedStrings?.invalid_email || 'Please enter a valid email address'
    return ''
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    
    const emailError = validateEmail(email)
    if (emailError) {
      setError(emailError)
      return
    }

    setLoading(true)
    try {
      const res = await axios.get(`${apiURL}/api/user/forgot/password`, {
        params: { username: email },
        headers: commonHeadersWeb,
      })
      setLoading(false)
      // Server returns HTTP 200 even on failures; success is signalled by the
      // response code (2000/200/0). A non-success code (e.g. 4002 INVALID_USER_ID)
      // means no email was sent, so don't show the "email sent" screen.
      if (isSuccessResponse(res?.data?.code)) {
        setSuccess(true)
      } else if (res?.data?.code === 4002) {
        setError(
          localizedStrings?.no_account_found ||
          'We couldn’t find an account with that email address.'
        )
      } else {
        setError(
          res?.data?.message ||
          localizedStrings?.error_message ||
          'An error occurred. Please try again.'
        )
      }
    } catch (error) {
      setLoading(false)
      setError(
        error?.response?.data?.message ||
        localizedStrings?.error_message ||
        'An error occurred. Please try again.'
      )
    }
  }

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams?.has('email') && isValidEmail(urlParams.get('email'))) {
      setEmail(urlParams.get('email'))
    }
  }, [])

  if (success) {
    return <Thankyou email={email} />
  }

  return (
    <>
      <SEOComponent
        title={'Reset your password | AUMHUM'}
        description={'Reset your password via email'}
        image={APP_CONSTANTS.APP_LOGO_LINK}
      />
      <div className="forgot-password-page">
        <div className="forgot-password-container">
          <div className="forgot-password-logo" onClick={() => navigate('/login')}>
            <img 
              src={APP_CONSTANTS.APP_LOGO_LINK} 
              alt="AUMHUM Logo" 
              onError={(e) => {
                e.target.src = logo
              }}
            />
          </div>

          <div className="forgot-password-card">
            <h1 className="forgot-password-title">
              {localizedStrings?.forgot_password || 'Forgot Password?'}
            </h1>
            <p className="forgot-password-subtitle">
              {localizedStrings?.forgot_password_instructions ||
                "Please enter your registered email address and we'll send you instructions to reset your password"}
            </p>

            <form onSubmit={handleSubmit} className="forgot-password-form">
              <div className="forgot-password-field-group">
                <label htmlFor="forgot-email" className="forgot-password-label">
                  {localizedStrings?.email || 'Email Address'}
                </label>
                <input
                  id="forgot-email"
                  type="email"
                  placeholder={localizedStrings?.email_placeholder || 'Enter your email'}
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value)
                    if (error) setError('')
                  }}
                  className={`forgot-password-input ${error ? 'forgot-password-input-error' : ''}`}
                  disabled={isLoading}
                  autoComplete="email"
                  aria-invalid={!!error}
                  aria-describedby={error ? 'forgot-email-error' : undefined}
                />
                {error && (
                  <span id="forgot-email-error" className="forgot-password-error" role="alert">
                    {error}
                  </span>
                )}
              </div>

              <button
                type="submit"
                className="forgot-password-submit-button"
                disabled={isLoading || !isValidEmail(email)}
              >
                {isLoading ? (
                  <>
                    <Spinner animation="border" variant="light" size="sm" className="me-2" />
                    {localizedStrings?.sending || 'Sending...'}
                  </>
                ) : (
                  localizedStrings?.continue || 'Continue'
                )}
              </button>
            </form>
          </div>
        </div>

        <div className="forgot-password-footer">
          <img src={footerImage} alt="Footer" />
        </div>
      </div>
    </>
  )
}

export default ForgotPassword
